'use client'
import Header from "@/components/layout/header";
import NoticeBanner from "@/components/layout/notice-banner";
import {useEffect, useState} from "react";
import {usePathname} from "next/navigation";
import BusmapBanner from "@/components/layout/busmap-banner";

import { useSearchParams } from 'next/navigation'
import CustomerService from "@/services/Bubble/finsey/CustomerService";

const HeaderContainer = () => {
    const [transparent, setTransparent] = useState<boolean>(false)
    const pathname = usePathname()
    // const transparentRouter = ['/bussiness','/course']
    const transparentRouter:any[] = ['/help-center']
    const blackTextHeaderRouter:any[] = ['/help-center']
    const searchParams = useSearchParams()
    const partner = searchParams.get('partner')
    const customerService = new CustomerService()

    useEffect(() => {
        if(partner == 'busmap'){
            customerService.sendBusmapTracking(pathname).then(item => {})
        }
    }, []);

    return (
        <div className={`${transparentRouter.includes(pathname) ? 'fixed' : 'sticky'} left-0 top-0 z-50 w-full bg-transparent`}>
            <Header transparent={transparentRouter.includes(pathname)} isBlackText={transparentRouter.includes(pathname)}/>
            {/*<NoticeBanner/>*/}
        </div>
    )
}

export default  HeaderContainer